import { render, staticRenderFns } from "./DivideItRightForm.vue?vue&type=template&id=71e06e61&scoped=true&lang=pug&"
import script from "./DivideItRightForm.vue?vue&type=script&lang=js&"
export * from "./DivideItRightForm.vue?vue&type=script&lang=js&"
import style0 from "./DivideItRightForm.vue?vue&type=style&index=0&id=71e06e61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e06e61",
  null
  
)

export default component.exports